module.exports = __webpack_public_path__ + "img/lock-closed-outline-dark.cddf409e.svg";